"use strict";
// import { _ShowErrorMessage } from '@src/const/dom-crud/generator.const';
// import { cloneDeep } from 'lodash';
// import { Api } from '../models/api.model';
// import { Lead } from '../models/customer.model';
// import { CustomerContract } from '../models/magicline.model';
// import { YondCurrentVersion, YondCustomerModel, YondServiceDetails, YondTariff, YondVariant } from '../models/yond.model';
// import { ObjectService } from '../services/object-service';
// import { SettingsService } from '../services/settings.service';
// import { betterFetch } from '@src/services/backend-services';
Object.defineProperty(exports, "__esModule", { value: true });
exports.YondCustomerCreationData = YondCustomerCreationData;
// export class YondApi implements Api {
//   private config = ObjectService.getInstance(SettingsService);
//   public async getStudios(): Promise<Studio[]> {
//     const studioUrl = `${this.config.get.yondUrl}/studios?tenantKey=${encodeURIComponent(this.config.get.tenantKey)}`;
//     return betterFetch(studioUrl, {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     })
//       .then(async (createResponse) => {
//         if (!createResponse.ok) {
//           return Promise.reject(createResponse.json());
//         }
//         console.log('studio res', createResponse);
//         const yondStudios = (await createResponse.json()) as any[];
//         console.log('got studios', yondStudios);
//         const convertedStudios = this.convertYondStudios(yondStudios);
//         console.log('converted studios', convertedStudios);
//         return convertedStudios;
//       })
//       .catch(async (createdErr) => {
//         const error = await createdErr;
//         if (error.message) {
//           _ShowErrorMessage(error.message);
//         }
//         throw error;
//       });
//   }
//   public async createNewCustomer(body: CustomerContract): Promise<void> {
//     const yondCustomer = this.convertToYondCustomer(body);
//     //const manychat = localStorage.getItem('manychat-lead-id');
//     const createCustomerUrl = `${this.config.get.yondUrl}/customer?tenantKey=${encodeURIComponent(this.config.get.tenantKey)}`;
//     return betterFetch(createCustomerUrl, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(yondCustomer),
//     })
//       .then(function (createResponse) {
//         if (!createResponse.ok) {
//           return Promise.reject(createResponse.json());
//         }
//         return createResponse.json();
//       })
//       .catch(async (createdErr) => {
//         const error = await createdErr;
//         if (error.message) {
//           _ShowErrorMessage(error.message);
//         }
//         throw error;
//       });
//   }
//   public async createTrialBooking(body: YondCustomerModel) {
//     const createCustomerUrl = `${this.config.get.yondUrl}/createTrialBooking?tenantKey=${encodeURIComponent(
//       this.config.get.tenantKey
//     )}`;
//     return betterFetch(createCustomerUrl, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(body),
//     })
//       .then(function (createResponse) {
//         if (!createResponse.ok) {
//           return Promise.reject(createResponse.json());
//         }
//         return createResponse.json();
//       })
//       .catch(async (createdErr) => {
//         const error = await createdErr;
//         if (error.message) {
//           _ShowErrorMessage(error.message);
//         }
//         throw error;
//       });
//   }
//   public async createLead(body: Lead): Promise<object> {
//     try {
//       body.studioId = +localStorage.getItem('studioOid');
//       body.notes =
//         body.notes +
//         'Studio name: ' +
//         localStorage.getItem('studioName') +
//         ', studioId: ' +
//         localStorage.getItem('studioId') +
//         ', studioOid: ' +
//         localStorage.getItem('studioOid');
//     } catch (e) {
//       console.error('yond lead error', e);
//     }
//     try {
//       return betterFetch(`${this.config.get.yondUrl}/lead`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(body),
//       });
//     } catch (e) {
//       console.error('yond lead request error', e);
//     }
//   }
//   // yond takes the studio id from localstorage
//   // its not used to get the right studio, its used for the mapping
//   // yond has no offering/location mapping, so it comes from the settings
//   public async getOfferings(studioId: string): Promise<IOffering[]> {
//     console.log('offering yond settings', this.config.get.yond);
//     let offeringUrl = `${this.config.get.yondUrl}/offerings?tenantKey=${encodeURIComponent(this.config.get.tenantKey)}`;
//     if (this.config.get.yond?.excludeTarifsWithExternalCode !== undefined) {
//       offeringUrl += `&filter=${encodeURIComponent(JSON.stringify(this.config.get.yond.excludeTarifsWithExternalCode))}`;
//     }
//     if (this.config.get.yond?.includeTarifsWithExternalCode !== undefined) {
//       offeringUrl += `&include=${encodeURIComponent(JSON.stringify(this.config.get.yond.includeTarifsWithExternalCode))}`;
//     }
//     const selectedStudioId = localStorage.getItem('studioId');
//     if (selectedStudioId && selectedStudioId != '') {
//       console.log('selected Studio: ', selectedStudioId);
//       if (this.config.get.yond?.studioLocationMapping) {
//         console.log('using yond studio tarif mapping');
//         const tarifsToShow = this.config.get.yond.studioLocationMapping[selectedStudioId];
//         if (!tarifsToShow) {
//           console.error(
//             'Selected studio',
//             selectedStudioId,
//             'has NO set tariff ids in the webflow settings, showing ALL tarifs!'
//           );
//         } else {
//           offeringUrl += `&tariffIds=${encodeURIComponent(JSON.stringify(tarifsToShow))}`;
//         }
//       } else {
//         console.log('Not using yond studio mapping, this can cause long loading times!');
//       }
//     }
//     return betterFetch(offeringUrl, {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     })
//       .then(async (createResponse) => {
//         if (!createResponse.ok) {
//           return Promise.reject(createResponse.json());
//         }
//         const yondTariffs = (await createResponse.json()) as YondTariff[];
//         console.log('got offerings', yondTariffs);
//         let convertedOffers = this.convertYondOffers(yondTariffs);
//         console.log('converted offerings', convertedOffers);
//         if (convertedOffers.filter((s) => s.id === undefined).length) {
//           console.error('Found a yond studio without id, filtering it out!');
//           convertedOffers = convertedOffers.filter((s) => s.id !== undefined);
//         }
//         return convertedOffers;
//       })
//       .catch(async (createdErr) => {
//         const error = await createdErr;
//         if (error.message) {
//           _ShowErrorMessage(error.message);
//         }
//         throw error;
//       });
//   }
//   private convertYondOffers(offerings: YondTariff[]): IOffering[] {
//     const offers: IOffering[] = [];
//     offerings.forEach((offering) => {
//       offering.variants.forEach((variant) => {
//         const hasMembership = this.yondVariantContainsMembership(variant);
//         if (!hasMembership) {
//           console.error(
//             'offering',
//             offering.current_version.name,
//             'has a variant',
//             variant.current_version.name,
//             'with no membership',
//             variant.current_version.services
//           );
//         } else {
//           const details = variant.current_version;
//           const subDes = this.createYondSubdescription(variant);
//           const allModules = variant.current_version.services.map((service) => this.convertYondServiceToModule(service));
//           const selectableModules = variant.current_version.services
//             .filter((serv) => serv.optional === true)
//             .map((service) => this.convertYondServiceToModule(service));
//           offers.push({
//             id: +variant.oid,
//             yondTerifOid: offering.oid,
//             description: variant.current_version.description,
//             name: variant.current_version.name,
//             subDescription: subDes,
//             preuseType: null,
//             terms: this.convertYondOfferTerm(details, variant.oid),
//             modules: allModules, // all addons
//             maximumNumberOfSelectableModules: selectableModules.length,
//             selectableModules: selectableModules, // not per default in package
//             imageUrl: null,
//             footnote: 'Footnote', // highlight contract details
//           } as IOffering);
//         }
//       });
//     });
//     return offers;
//   }
//   // TODO: technically we have to take in count the period type (month, year) for the termValueWithoutBonusPeriod
//   private convertYondOfferTerm(offering: YondCurrentVersion, variantOid: string): ITerm[] {
//     const possibleServices = offering.services.filter(
//       (serv) =>
//         serv.service.add_on === false && serv.optional === false && this.yondCategoryIsMembership(serv.service.category?.name)
//     );
//     if (possibleServices.length !== 1) {
//       console.error(
//         'Found',
//         possibleServices.length,
//         'Yond membership services in this variant, that are not addon and not optional, this is NOT supported and will lead to problems!',
//         offering.services
//       );
//     }
//     const service = offering.services.find(
//       (serv) =>
//         serv.service.add_on === false && serv.optional === false && this.yondCategoryIsMembership(serv.service.category?.name)
//     );
//     if (!service) {
//       console.error('All services for offering', offering.name, 'are addons or optional');
//       return [];
//     }
//     // cancelation
//     const cancellationPeriods = offering.cancellation_periods;
//     const cancellationPeriod = cancellationPeriods.length > 0 ? cancellationPeriods[0].amount : null;
//     const cancellationPeriodUnit = cancellationPeriods.length > 0 ? cancellationPeriods[0].period : null;
//     // extension
//     const extensionPeriods = offering.extension_periods;
//     const extensionPeriod = extensionPeriods.length > 0 ? extensionPeriods[0].amount : null;
//     const extensionPeriodUnit = extensionPeriods.length > 0 ? extensionPeriods[0].period : null;
//     // recurring fees currently moved to optional modules, since magicline doesnt support recurring fees ?
//     // EVERYTHING EXCEPT MEMBERSHIP AND NOT OPTIONAL IS A FEE
//     const reoccuringFees = offering.services.filter(
//       (serv) =>
//         serv.price_frequency_unit !== 'ONCE' &&
//         serv.optional === false &&
//         !this.yondCategoryIsMembership(serv.service.category?.name)
//     );
//     const resReoccuringFees = reoccuringFees.map((offer) => {
//       return {
//         identifier: offer.service.name,
//         name: offer.service.name,
//         price: offer.price,
//         paymentFrequencyType: 'RECURRING',
//         paymentFrequencyUnit: offer.price_frequency_unit,
//         paymentFrequencyValue: offer.price_frequency,
//         paymentFrequency: offer.price_frequency + ' ' + offer.price_frequency_unit,
//       } as IFlatfee;
//     });
//     const flatFees = offering.services.filter(
//       (serv) => serv.price_frequency_unit === 'ONCE' && !this.yondCategoryIsMembership(serv.service.category?.name)
//     );
//     const resFlatFess = [
//       ...resReoccuringFees,
//       ...flatFees.map((offer) => {
//         return {
//           identifier: offer.service.name,
//           name: offer.service.name,
//           price: offer.price,
//           paymentFrequency: 'einmalig',
//           paymentFrequencyType: 'NON_RECURRING',
//         } as IFlatfee;
//       }),
//     ];
//     // addons
//     const optionalServices = offering.services.filter((serv) => serv.service.add_on === true && serv.optional === true);
//     const optionalModules = optionalServices.map((offer) => {
//       return this.convertYondServiceToModule(offer);
//     });
//     if (optionalModules.length > 0) {
//       console.log('Yond variant oid', variantOid, 'offering', offering, 'has optional modules:', optionalModules);
//     }
//     return offering.contract_terms.map((term) => {
//       const yondTerm = {
//         id: +variantOid,
//         defaultContractStartDate: null, // date when the contract starts
//         contractStartDateOfUse: null,
//         termValue: term.amount, // important number of months/days per term
//         termValueWithoutBonusPeriod: term.amount, //term.amount - service.bonus_period,
//         termUnit: term.period, // month, year, week etc
//         paymentFrequencyValue: service.price_frequency,
//         paymentFrequencyUnit: service.price_frequency_unit, // month, year, week etc
//         paymentFrequencyType: 'RECURRING', // recurring, or once
//         price: service.price, // think its per month/term not total
//         currencyCode: service.currency,
//         priceAdjustmentRules: [],
//         flatFees: resFlatFess,
//         extensionFixedTerm: extensionPeriod,
//         extensionFixedTermUnit: extensionPeriodUnit,
//         extensionType: 'TERM_EXTENSION',
//         cancellationPeriod: cancellationPeriod,
//         cancellationPeriodUnit: cancellationPeriodUnit,
//         extensionCancellationPeriod: null,
//         extensionCancellationPeriodUnit: null,
//         rateBonusPeriods: [],
//         rateStartPrice: null,
//         optionalModules: optionalModules, // add ons optional in contract,
//       } as ITerm;
//       if (service.price_periods.length > 1) {
//         yondTerm.subsequentRateDto = this.mapYondSubsequentPrices(service, yondTerm);
//       }
//       return yondTerm;
//     });
//   }
//   private mapYondSubsequentPrices(service: YondServiceDetails, term: ITerm): IOffering {
//     if (service.price_periods.length > 1) {
//       const adjustment = service.price_periods[1];
//       const termCopy = cloneDeep(term);
//       termCopy.price = adjustment.price;
//       const res: IOffering = {
//         terms: [termCopy],
//       } as IOffering;
//       return res;
//     }
//     return undefined;
//   }
//   private convertYondServiceToModule(service: YondServiceDetails) {
//     return {
//       id: +service.service.oid,
//       name: service.service.name,
//       description: service.service.description,
//       paymentFrequencyValue: service.price_frequency,
//       paymentFrequencyType: service.price_frequency_unit === 'ONCE' ? 'ONCE' : 'RECURRING',
//       paymentFrequencyUnit: service.price_frequency_unit,
//       price: service.price,
//     } as IOptionalModule;
//   }
//   private createYondSubdescription(variant: YondVariant): string {
//     const benefitInclude = this.config.get.yond?.includeBenefitDescriptionWithExternalCode;
//     const service = variant.current_version.services.find(
//       (serv) =>
//         serv.service.add_on === false && serv.optional === false && this.yondCategoryIsMembership(serv.service.category?.name)
//     );
//     if (!service) {
//       console.error('No membership found for tarif variant', variant.current_version.name, 'can not generate subdescription!');
//       return '';
//     }
//     const filteredBenefits = service.service.benefits.filter(
//       (ben) => !benefitInclude || benefitInclude.length === 0 || benefitInclude.includes(ben.benefit.external_code)
//     );
//     const allBenefits = filteredBenefits.map((ben) => ben.benefit.name);
//     const subDes = allBenefits?.reduce((sum, item) => sum + '\n' + item, '') || '';
//     return subDes;
//   }
//   private convertYondStudios(yondStudios: any[]): Studio[] {
//     return yondStudios.map((yondStudio) => {
//       return {
//         id: yondStudio.id,
//         yondStudioOid: yondStudio.oid,
//         yondLegalEntitiyOid: yondStudio.legal_entity_oid,
//         studioName: yondStudio.name,
//         studioPhone: yondStudio.support_phone?.number,
//         studioEmail: yondStudio.support_email?.address,
//         trialSessionBookable: false,
//         address: {
//           street: yondStudio.address?.street || '',
//           city: yondStudio.address?.city || '',
//           zipCode: yondStudio.address?.postal || '',
//           countryCode: yondStudio.address?.country.dial_code || '',
//           countryCodeAlpha2: yondStudio.address?.country.dial_code || '', // Assuming the same as `countryCode`
//           longitude: yondStudio.longitude,
//           latitude: yondStudio.latitude,
//           houseNumber: yondStudio.address?.house_nr,
//         },
//         zoneId: 'Unknown Zone', // Placeholder if zone data is not available
//         masterStudioId: null,
//         openingDate: null,
//         closingDate: null,
//         openingHours: [],
//         currencyCode: 'EUR',
//       } as Studio;
//     });
//   }
//   private convertToYondCustomer(body: CustomerContract): YondCustomerModel {
//     const selectedContractId = localStorage.getItem('contract.rateBundleTermId');
//     const selectedStudioId = localStorage.getItem('studioOid');
//     const selectedTermNum = localStorage.getItem('contract.rateBundleTermDuration');
//     const legalEntityOid = localStorage.getItem('legalEntityOid');
//     const givenConsents = this.config.get.yond?.givenConsentNames || [];
//     const contractStartDate = this.config.get.yond?.contractStartDate;
//     const contractUsageStartDate = this.config.get.yond?.contractUsageStartDate;
//     const bankInfo = body.customer.bankAccount;
//     const testCustomer = localStorage.getItem('testCustomer') === 'true';
//     const optionalModules = JSON.parse(localStorage.getItem('optionalModules') || '[]');
//     let phonePrefix = localStorage.getItem('customer.phonePrefix');
//     if (!phonePrefix) {
//       console.error('Missing phone prefix');
//       phonePrefix = '+49';
//     }
//     const mobile_phone = body.customer.telephone_mobile.includes('+')
//       ? body.customer.telephone_mobile
//       : phonePrefix + body.customer.telephone_mobile;
//     //console.log("using localstorage data contract", selectedContractId, "and studio", selectedStudioId, "with term", selectedTermNum, "and legal entitity", legalEntityOid)
//     const customer: YondCustomerModel = {
//       // all of these are custom values needed by yond
//       home_facility_oid: selectedStudioId,
//       tariff_variant_oid: selectedContractId,
//       selectedTerm: selectedTermNum,
//       legalEntityOid: legalEntityOid,
//       bankInfo: bankInfo,
//       givenConsents: givenConsents,
//       contractStartDate,
//       contractUsageStartDate,
//       phonePrefix: phonePrefix,
//       optionalModules,
//       // the customer itself
//       person: {
//         gender: body.customer.gender == 'UNISEX' ? 'NONBINARY' : body.customer.gender,
//         birth_dt: body.customer.dateOfBirth,
//         test: testCustomer,
//         name: {
//           first_name: body.customer.firstname,
//           last_name: body.customer.lastname,
//         },
//         addresses: [
//           {
//             country_oid: '65', // mapped in backend
//             city: body.customer.city,
//             postal: body.customer.zipCode,
//             street: body.customer.street,
//             house_nr: body.customer.houseNumber,
//             country_code: body.customer.countryCode,
//           },
//         ],
//         phones: [
//           {
//             number: mobile_phone, // TODO interface does not include selected phone prefix
//             country_oid: '65',
//           },
//         ],
//         emails: [
//           {
//             address: body.customer.email,
//           },
//         ],
//       },
//     };
//     return customer;
//   }
//   //   // This can be used e.g. to validate a voucher
//   // eslint-disable-next-line @typescript-eslint/no-unused-vars
//   public previewNewCustomer(body: CustomerContract): Promise<Response> {
//     console.error('PREVIEW CUSTOMER NOT DEFINED FOR YOND API');
//     return undefined;
//   }
//   // eslint-disable-next-line @typescript-eslint/no-unused-vars
//   public async validateVoucher(body: CustomerContract): Promise<{
//     message?: string;
//     voucherSuccessMessage?: string;
//     voucherRemarks?: string;
//   }> {
//     console.error('VOUCHERS NOT DEFINED FOR YOND API');
//     return undefined;
//   }
//   public yondCategoryIsMembership(category?: string) {
//     return (
//       category === 'Membership' || category === 'Memberships' || category === 'Mitgliedschaft' || category === 'Mitgliedschaften'
//     );
//   }
//   public yondVariantContainsMembership(variant: YondVariant) {
//     return (
//       variant.current_version.services.filter(
//         (serv) =>
//           serv.service.add_on === false && serv.optional === false && this.yondCategoryIsMembership(serv.service.category?.name)
//       ).length > 0
//     );
//   }
// }
function YondCustomerCreationData(config) {
    var _a, _b, _c;
    var selectedStudioId = localStorage.getItem('studioOid');
    var selectedTermNum = localStorage.getItem('contract.rateBundleTermDuration');
    var selectedTermValue = (selectedTermNum === null || selectedTermNum === void 0 ? void 0 : selectedTermNum.split(' ')[0]) || '';
    var selectedTermUnit = (selectedTermNum === null || selectedTermNum === void 0 ? void 0 : selectedTermNum.split(' ')[1]) || '';
    var legalEntityOid = localStorage.getItem('legalEntityOid');
    var givenConsents = ((_a = config.get.yond) === null || _a === void 0 ? void 0 : _a.givenConsentNames) || [];
    var contractStartDate = (_b = config.get.yond) === null || _b === void 0 ? void 0 : _b.contractStartDate;
    var contractUsageStartDate = (_c = config.get.yond) === null || _c === void 0 ? void 0 : _c.contractUsageStartDate;
    var testCustomer = localStorage.getItem('testCustomer') === 'true';
    var optionalModules = JSON.parse(localStorage.getItem('optionalModules') || '[]');
    var phonePrefix = localStorage.getItem('customer.phonePrefix');
    if (!phonePrefix) {
        console.error('Missing phone prefix');
        phonePrefix = '+49';
    }
    return {
        name: 'yond',
        studioOid: selectedStudioId !== null && selectedStudioId !== void 0 ? selectedStudioId : '',
        selectedTermValue: selectedTermValue,
        selectedTermUnit: selectedTermUnit,
        legalEntityOid: legalEntityOid !== null && legalEntityOid !== void 0 ? legalEntityOid : '',
        givenConsents: givenConsents,
        contractStartDate: contractStartDate,
        contractUsageStartDate: contractUsageStartDate,
        testCustomer: testCustomer,
        phonePrefix: phonePrefix,
        optionalModules: optionalModules,
    };
}
